import { Component, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { EmailConfigService } from 'src/app/private/services/emailconfig.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { CreateEmailConfigComponent } from "../create-email-config/create-email-config.component";
import { CenterService } from 'src/app/private/services/center.service';
import { DeleteEmailConfigComponent } from "../delete-email-config/delete-email-config.component";

@Component({
  selector: 'app-email-config',
  imports: [SharedModule, CreateEmailConfigComponent, DeleteEmailConfigComponent],
  templateUrl: './email-config.component.html',
  styleUrl: './email-config.component.scss'
})
export class EmailConfigComponent {
   @Input() clientId!: string;
  emailConfigs: any[] = [];
  totalRecords = 0;
  rows = 10;
  loading = true;

  displayAddModal = false;
  showEditConfig = false;
  showDeleteConfig = false;
  configDataToEdit: any = null;
  centers: any[] = [];

  configActionItem: MenuItem[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Config',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.showEditConfig = true;
          },
        },
        {
          label: 'Delete Config',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.showDeleteConfig = true;
          },
        },
      ],
    },
  ];

  constructor(private emailConfigService: EmailConfigService,
    private centerService: CenterService
  ) {}

  ngOnInit(): void {
    this.loadCenters({ first: 0, rows: this.rows });
  }

  openAddModal() {
    this.displayAddModal = true;
  }

  closeAddModal() {
    this.displayAddModal = false;
  }

  setConfigData(data: any) {
    this.configDataToEdit = data;
  }

  loadConfigs(event: any): void {
    this.loading = true;

    const payload = {
      page: 0,
      limit: 100,
      where: {
        client_id: this.clientId,
      },
      order: {
        col: '"client_email_config"."updatedAt"',
        dir: 'DESC',
      },
    };

    this.emailConfigService.getAllEmailConfigs(payload).subscribe({
      next: (data) => {
        this.emailConfigs = data?.rows || [];
        this.totalRecords = data?.count || 0;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading configs:', err);
        this.loading = false;
      },
    });
  }

  reload() {
    this.loadConfigs({ first: 0, rows: this.rows });
  }


    loadCenters(event: any): void {
    this.loading = true;
    const payload = {
      "page": 0,
      "limit": 100,
      "where": {
        "client_id": this.clientId,
      },
      "order": {
        "col": "\"center\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    this.centerService.getAllCenterWithCount(payload).subscribe({
      next: (data) => {
        this.centers = data?.rows || [];
        this.totalRecords = data?.count || 0;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading centers:', err);
        this.loading = false;
      }
    });
  }
  

}
